module.exports = __webpack_public_path__ + "img/home-white.21cafd34.svg";